export default function imagesReducer(state = {}, action) {
  return state;
}


// WEBPACK FOOTER //
// ./src/reducers/images.js